const stats = [
  { value: '14+', label: 'Shopping Categories' },
  { value: '1,000+', label: 'Verified Product Links' },
  { value: '30+', label: 'In-Depth Guides' },
  { value: '100%', label: 'Free To Access' },
];

const highlights = [
  'Updated 2026 Links',
  '15 Shopping Categories',
  'Independent Reviews',
  'Buyer Safe Guides',
];

export default function AboutStats() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-accent-50">
      <div className="max-w-6xl mx-auto">
        <div className="inline-flex items-center px-4 py-1.5 bg-background-50 rounded-full mb-8">
          <span className="text-xs font-semibold text-accent-700 font-label">Sugargoo Resource #1</span>
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 font-heading leading-[1.15] mb-12 max-w-2xl">
          The Complete Sugargoo<br />Spreadsheet Directory
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mb-12">
          {highlights.map((item) => (
            <p key={item} className="text-sm md:text-base text-foreground-700 font-medium">
              {item}
            </p>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label}>
              <p className="text-4xl md:text-5xl font-bold text-accent-600 font-heading mb-2">
                {stat.value}
              </p>
              <p className="text-xs md:text-sm text-foreground-400 font-label uppercase tracking-wide">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}